


























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GCheckboxForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: Boolean as PropType<boolean> },
    label: { type: String as PropType<string> },
    name: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gCheckboxFormProvider as any).validate();
    },
  },
});
